import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BundlingProductTab from '../components/BundlingProductTab';
import IeemWorkspaceTabs from '../components/IeemWorkspaceTabs';
import EmptyStateBlock from '../components/bundling/EmptyStateBlock';
import PageHeader from '../components/bundling/PageHeader';
import { Card, CardContent } from '@/components/ui/card';

const Airports = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedRole, user } = useAuth();

  const isIeemRoute = location.pathname.includes('/airports/ieem') || location.pathname === '/admin/airports/ieem';
  const isBundlingProductRoute =
    location.pathname.includes('/airports/bundling-product') || location.pathname === '/admin/airports/bundling-product';

  const [activeIeemTab, setActiveIeemTab] = useState(0);

  useEffect(() => {
    if (location.pathname === '/admin/airports/ieem' || location.pathname === '/admin/airports') {
      navigate('/admin/airports/ieem', { replace: true });
    }
  }, [location.pathname, navigate]);

  const userRole = user?.role || '';
  let parsedUserRoles = [];
  if (userRole) {
    if (Array.isArray(userRole)) {
      parsedUserRoles = userRole;
    } else if (typeof userRole === 'string') {
      if (userRole.includes(';')) {
        parsedUserRoles = userRole.split(';').map((r) => r.trim()).filter((r) => r);
      } else if (userRole.includes(',')) {
        parsedUserRoles = userRole.split(',').map((r) => r.trim()).filter((r) => r);
      } else if (userRole.trim()) {
        parsedUserRoles = [userRole.trim()];
      }
    }
  }

  const hasRoleIeem = selectedRole === 'ieem' || (!selectedRole && parsedUserRoles.includes('ieem'));
  const hasRoleBp = selectedRole === 'bp' || (!selectedRole && parsedUserRoles.includes('bp'));

  const getMemberCode = () => 'api';

  const eyebrow = isIeemRoute ? 'IEEM Workspace' : isBundlingProductRoute ? 'Product Workspace' : 'Domain Workspace';

  return (
    <div>
      <div className="mb-6 flex flex-col gap-4">
        <PageHeader
          eyebrow={eyebrow}
          title="Injourney Airports"
          description="Kelola channel publishing IEEM dan bundling product untuk Injourney Airports."
        />
      </div>

      <Card className="rounded-2xl border-0 bg-white shadow-sm">
        <CardContent className="p-2 lg:p-4">
          {isIeemRoute && hasRoleIeem ? (
            <IeemWorkspaceTabs
              activeIeemTab={activeIeemTab}
              onTabChange={setActiveIeemTab}
              memberCode={getMemberCode()}
              productsContent={
                <EmptyStateBlock
                  title="Products workspace akan segera tersedia"
                  description="Daftar product readiness untuk InJourney Airports akan ditampilkan di sini."
                />
              }
              analyticsContent={
                <EmptyStateBlock
                  title="Analytics workspace belum tersedia"
                  description="Summary analytics dan exception readiness Airports akan muncul setelah data source terhubung."
                />
              }
            />
          ) : isBundlingProductRoute && hasRoleBp ? (
            <BundlingProductTab memberId={getMemberCode()} />
          ) : (
            <div className="flex flex-col gap-4">
              <p className="text-slate-600">Memuat...</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Airports;
